
export const OFFICE_DESK_TYPES = ['Yazı Masası', 'Bilgisayar Masası', 'Köşe Masa', 'Toplantı Masası', 'Resepsiyon Masası', 'Stand-up Desk'];

export const OFFICE_CHAIR_FEATURES = ['Ayarlanabilir Kolçak', 'Ayarlanabilir Sırt', 'Lumbar Destek', 'Başlık', 'Döner', 'Tekerlekli'];

export const POWER_TOOL_TYPES = ['Matkap', 'Vidalama', 'Taşlama', 'Testere', 'Zımpara', 'Freze', 'Kırıcı Delici', 'Kompresör', 'Kaynak Makinesi'];

export const WORK_MACHINE_TYPES = ['Jeneratör', 'Kaynak Makinesi', 'Beton Mikseri', 'Vinç', 'Forklift', 'Ekskavatör', 'Yükleyici'];

export const CONSTRUCTION_PAINT_TYPES = ['İç Cephe Boyası', 'Dış Cephe Boyası', 'Su Bazlı', 'Yağlı Boya', 'Akrilik', 'Saten', 'Mat'];

export const GARDEN_TOOL_POWER = ['Manuel', 'Elektrikli', 'Akülü', 'Benzinli'];
